import CustomerInspectionsHtml from './customer.inspections.html';

export function CustomerInspectionsDirective () {
  return {
    controller: 'CustomerInspectionsCtrl',
    restrict: 'E',
    templateUrl: CustomerInspectionsHtml,
    scope: {
      customer: '=',
      inspections: '='
    }
  }
}
